
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/home/landing",
      function () {
        return require("private-next-pages/home/landing.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/home/landing"])
      });
    }
  